// PaperVerse Writer — Layer 2 deep-link event bus.
//
// Diagnostic-specific CTAs in the compile banner cannot open panels
// directly without coupling the banner to WriterProject internals.
// Instead they dispatch a tiny window CustomEvent that the chat pane
// (and future panels) subscribe to. Prefill semantics only — nothing
// auto-sends, so the author reviews the suggested prompt before it
// spends any tokens.
//
// See `src/components/writer/WriterCompileStatusBanner.tsx`.

export const WRITER_PREFILL_PROMPT_EVENT = 'writer:prefill-prompt';

export interface WriterPrefillPromptDetail {
  prompt: string;
  /** Optional — future panels may scope prefill by project. */
  projectId?: string;
  /** Diagnostic CTA that emitted the prompt, for telemetry/debug. */
  source?: string;
}

export function dispatchWriterPrefillPrompt(
  detail: WriterPrefillPromptDetail,
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<WriterPrefillPromptDetail>(WRITER_PREFILL_PROMPT_EVENT, {
      detail,
    }),
  );
}
